import React, { useState, useEffect } from "react";
import TitlePages from "../../layout/TitlePages";
import Breadcrumbs from "../../layout/Breadcrumbs";
import { EnCorto } from "../../data/EnCorto/dataEnCorto";
import "bootstrap/dist/css/bootstrap.min.css";


const EnCortoComponent = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedVideoUrl, setSelectedVideoUrl] = useState(null);

  useEffect(() => {
    document.title = `En Corto`;
  }, []);

  const openModal = (facebookWatchUrl) => {
    // Convierte la URL de Facebook Watch en una URL de iframe embebido
    const embedUrl = `https://www.facebook.com/plugins/video.php?href=${encodeURIComponent(
      facebookWatchUrl
    )}&show_text=0&autoplay=1`;
    setSelectedVideoUrl(embedUrl);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedVideoUrl(null);
  };

  
  return (
    <>
      <div className="margin-bottom-2">
        <Breadcrumbs
          path={[{ label: "Comunicación Social" }, { label: "En Corto" }]}
        />
        <TitlePages title="Comunicación Social" subTitle="En Corto" />

        <div className="container mt-4">
          <div className="row">
            {EnCorto.map((item) => (
              <div key={item.id} className="col-md-6 mb-4">
                <div
                  className="card h-100 shadow-sm position-relative"
                  onClick={() => openModal(item.facebookUrl)}
                  style={{ cursor: "pointer" }}
                >
                  <div className="ratio ratio-16x9">
                  <img
                    src="https://itetlax.org.mx/assets/img/encorto.png"
                    alt="Miniatura"
                    className="w-100 h-100 object-fit-cover"
                  />
                    <div className="position-absolute top-0 start-0 w-100 h-100 d-flex flex-column justify-content-center align-items-center bg-dark bg-opacity-50">
                    <i className="bi bi-play-circle-fill text-white fs-1"></i>
                    <p
                    className="text-white mt-2 mb-0"
                    style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}
                  >
                    {item.nuevo ? (
                      <>
                        <span style={{ fontWeight: "bold" }}>¡NUEVO VIDEO!</span>
                        <span>Haz clic para reproducir</span>
                      </>
                    ) : (
                      "Haz clic para reproducir"
                    )}
                  </p>
                  </div>
                  </div>
                  <div className="card-body">
                    <h5 className="card-title">{item.titleItem}</h5>
                    <p className="card-text">{item.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Modal con iframe de Facebook */}
      {isModalOpen && (
        <div
          className="modal fade show"
          style={{ display: "block", backgroundColor: "rgba(0,0,0,0.7)" }}
          onClick={closeModal}
        >
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <div className="modal-body p-0">
                <div className="ratio ratio-16x9">
                  <iframe
                    src={selectedVideoUrl}
                    title="Video de Facebook"
                    allowFullScreen
                    allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
                    className="w-100 h-100"
                    style={{ border: "none" }}
                  ></iframe>
                </div>
              </div>
              <button
                className="btn btn-danger position-absolute top-0 end-0 m-2"
                onClick={closeModal}
              >
                <i className="bi bi-x-lg"></i>
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};



export default EnCortoComponent;
